import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { BrandProfileListItemResource } from 'dy-frontend-http-repository/lib/modules/BrandProfile/resources';
import domain from './domain';
import { resetClientBrandProfiles } from './events';

export const $clientBrandProfiles = domain
    .createStore<CollectionResource<BrandProfileListItemResource, {}> | null>(null)
    .reset(resetClientBrandProfiles);
